<template>
  <div>
    <Article v-if="$route.path == '/dashboard/store/article'" />
    <!-- Article  $t('article')-->
    <Sound v-if="$route.path == '/dashboard/store/sound'" />
    <!-- Sound $t('sound')-->
    <Video v-if="$route.path == '/dashboard/store/video'" />
    <!-- Video $t('video') -->
  </div>
</template>

<script>
import Article from "./_article/article_index.vue";
import Sound from "./_sound/sound_index.vue";
import Video from "./_video/video_index.vue";
export default {
  components: {
    Article,
    Sound,
    Video
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
